/**
 * Lets Jet apply evidence extraction onto the live Create Demand form.
 * Intake registers while mounted; Jet calls through when the user confirms.
 */

let intakeHandler = null;

/**
 * @param {{
 *   applyExtraction: (payload: { fields: object, files?: File[] }) => boolean | void,
 * }} handler
 * @returns {() => void} unregister
 */
export function registerJetIntakeHandler(handler) {
  intakeHandler = typeof handler?.applyExtraction === 'function' ? handler : null;
  return () => {
    if (intakeHandler === handler) intakeHandler = null;
  };
}

export function isJetIntakeActive() {
  return Boolean(intakeHandler);
}

/**
 * Create Demand registers on mount; on a heavier account that can lag behind
 * the extraction result appearing, so wait briefly for it before giving up.
 * @param {{ fields: object, files?: File[] }} payload
 * @returns {Promise<boolean>}
 */
export async function applyJetIntakeExtraction(payload) {
  for (let attempt = 0; attempt < 10 && !intakeHandler; attempt += 1) {
    await new Promise((resolve) => setTimeout(resolve, 150));
  }
  if (!intakeHandler) return false;
  try {
    const result = intakeHandler.applyExtraction(payload || {});
    return result !== false;
  } catch {
    return false;
  }
}

export function clearJetIntakeHandlerForTests() {
  intakeHandler = null;
}
